<script lang="ts" setup>
import { useTranslations } from '~/composables/translations';
import type { HomepageJourneyCard } from '../../models/homepage';
import { onMounted, ref } from 'vue';
import vuLazy from '@ds/vuekit/src/components/vu-lazy.vue';

const { $i18n } = useTranslations('common');
const props = defineProps<{
  content: HomepageJourneyCard;
}>();
const filePath = ref('');

onMounted(async () => {
  const images = import.meta.glob('/assets/images/homepage/journey/*');
  // @ts-expect-error dynamic glob import result is untyped
  filePath.value = (
    await images['/assets/images/homepage/journey/' + props.content.image]()
  ).default;
});
</script>
<template>
  <div class="journey-content-container flex flex-column relative">
    <div class="subtitle pa-10px">
      {{ props.content.name }}
    </div>
    <div
      class="journey-onHover-content pa-10px flex align-items-center justify-center text-center text-content"
    >
      {{ props.content.content }}
    </div>
    <div class="journey-content">
      <div class="text-right learn-more pa-10px text-content">{{ $i18n('learnMore') }}...</div>
      <vu-lazy height="170px">
        <div class="journey-image" :style="`background-image: url('${filePath}');`" />
      </vu-lazy>
    </div>
  </div>
</template>
<style lang="css" scoped>
.journey-content-container {
  border: 1px solid #d1d4d4;
  border-top: 4px solid #368ec4;
  overflow: hidden;
  background-color: white;
  z-index: 2;
}

.subtitle {
  color: #42a2da;
  background-color: #fff;
  height: 80px;
  z-index: 6;
}

.learn-more {
  background-color: #f9f9f9;
  z-index: 2;
  height: 40px;
  position: relative;
  transition: transform 300ms ease-in-out;
}

.journey-image {
  height: 170px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.journey-onHover-content {
  position: absolute;
  z-index: 1;
  top: 80px;
  height: 210px;
  width: 100%;
  transform: translateY(-170px);
  transition: transform 300ms ease-in-out;
  background-color: #f9f9f9;
  font-size: 17px;
}
.journey-content-container:hover .journey-onHover-content {
  transform: translateY(0);
  z-index: 3;
}

.journey-content-container:hover .learn-more {
  transform: translateY(210px);
  z-index: 3;
}
</style>
